import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, of } from 'rxjs';
import { APP_CONFIG } from '../../global/config/config.token';
import { AppConfig } from '../../global/config/app.config';
import { EventModel } from '../models/EventModel';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  constructor(private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig) { }

  createEvent(event: any, campaignId: number): Observable<any> {
    const payload = {
      event: {...event, ProjectedExpense: event.eventBudget },
      campaignId: campaignId
    };
    return this.http.post(`${this.config.apiUrl}event/add-event?campaignId=${campaignId}`, payload, { withCredentials: true });
  }

  validateEventCode(query: string, campaignId: number): Observable<any> {
    return this.http.get(`${this.config.apiUrl}event/validate`, {
      params: { eventCode: query, campaignId: campaignId }, withCredentials: true
    });
  }

  searchEventCodes(query: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.config.apiUrl}event/event-codes`, {
      params: { search: query },
    }).pipe(
      catchError(() => of([])) // Return empty array on error
    );
  }
  
  // GET ===================================================================================================================

  getEvent(eventId:number):Observable<any> {
    return this.http.get<any>( `${this.config.apiUrl}event/get-event-details?eventId=${eventId}`, { withCredentials: true });
  }

  getInitiative(eventId:number):Observable<any> {
    return this.http.get<any>( `${this.config.apiUrl}event/get-initiative-details?eventId=${eventId}`, { withCredentials: true });
  }

  getEventTypes(campaignId:number):Observable<any> {
    return this.http.get<any>( `${this.config.apiUrl}event/event-types?campaignId=${campaignId}`, { withCredentials: true });
  }
  
  // UPDATE =================================================================================================================

  updateEvent( event:EventModel  ):Observable<any> {
    //const sendObj:any = {Event:event, campaignId };
    return this.http.post<any>( 
        `${this.config.apiUrl}event/update-event`, 
        event,
        { withCredentials: true }
      )
  }
  
  /**
   * This function will be called for all update/delete batch operations.
   * @param action 
   * @param ids 
   * @returns 
   */
  batch( action:string, ids:Array<number> ):Observable<any> {
    const sendObj:EventAction = new EventAction(action, ids);
    return this.http.post<any>( 
        `${this.config.apiUrl}event/batch`, 
        sendObj,
        { withCredentials: true }
      );
  }

  
  updateInitiative( umbrellaObject:any ):Observable<any> {
    if(umbrellaObject.model.Initiative)delete umbrellaObject.model.Initiative; // causes issue with object parsing on the server side...
    return this.http.post<any>( 
        `${this.config.apiUrl}event/update-initiative`, 
        umbrellaObject,
        { withCredentials: true }
      );
  }

  // DELETE =================================================================================================================

  deleteEvent( eventId:number, campaignId:number ):Observable<any> {
    return this.http.get<any>( 
        `${this.config.apiUrl}event/delete-event?eventId=${eventId}`, 
        { withCredentials: true }
      );
  }

}


export class EventAction{
  action:string|null = null;
  ids:Array<number> = [];

  constructor(_action:string, _ids:Array<number>){
    this.action = _action;
    this.ids = _ids;
  }
}